import TSettingUsersEdit from './index.vue';

TSettingUsersEdit.install = app => {
  app.component(TSettingUsersEdit.name, TSettingUsersEdit);
};

export default TSettingUsersEdit;
